import { moveSprintInteraction } from '../utils/performance-analytics/index.tsx';

export const setMoveSprintInteractionStartMark = () => {
	moveSprintInteraction.start();
};

export const cancelMoveSprintInteraction = () => {
	moveSprintInteraction.cancel();
};

export const stopMoveSprintInteraction = () => {
	moveSprintInteraction.stop();
};
